import { Subject, merge } from 'rxjs'

import { BpmnMouseEvent } from '@flowx/designer/modules/bpmn-editor/bpmn-editor.types'
import { SwimlaneSummary } from '@flowx/designer/modules/core/dictionary/swimlane.dictionary'

const leftClick = new Subject<BpmnMouseEvent<SwimlaneSummary>>()
const rightClick = new Subject<BpmnMouseEvent<SwimlaneSummary>>()
const click = merge(leftClick, rightClick)
const contextMenuPaste = new Subject<void>()

export const BpmnSwimlaneRxjsEvents = {
  leftClick,
  rightClick,
  click,
  contextMenuPaste,
}
